import { Pagination } from "@/api/pagination";
import { of, Observable, async } from "rxjs";
import { map } from "rxjs/operators";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { PagamentoAPI } from "@/api/pagamento.api";
import { PagePagamentoInput, Pagamento } from "@/models/pagamento";
import Axios from "axios-observable";

const api = new PagamentoAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<Pagamento> => {
  return api.show(id);
}

const create = (pagamento: Pagamento): AxiosObservable<Pagamento> => {
  return api.create(pagamento);
};

const update = (
  id: number,
  pagagamento: Pagamento
): AxiosObservable<Pagamento> => {
  return api.update(id, pagagamento);
};

const listStatus = (): Observable<any> => {
  return api.listStatus();
}

const confirm = (id: number, body: any): AxiosObservable<any> => {
  return api.confirm(id, body);
}

export default {
  list,
  show,
  create,
  update,
  listStatus,
  confirm
};
